<template>
  <div class="create-role">
    <page-title :title="detail ? '角色信息' : '新建角色'" />
    <el-form ref="form" :model="form" :rules="rules" label-width="70px" hide-required-asterisk style="margin-top: 6px;">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model.trim="form.roleName" :readonly="detail && !edit" :maxlength="25" show-word-limit placeholder="请输入" class="w250" />
      </el-form-item>
      <el-form-item label="角色描述" prop="roleDesc">
        <el-input v-model.trim="form.roleDesc" :rows="4" :readonly="detail && !edit" type="textarea" :maxlength="100" show-word-limit class="w250" />
      </el-form-item>
      <el-form-item label="角色权限">
        <div v-if="infoLoadStatus === 'loaded' && (!authTree || authTree.length === 0)" style="color: rgba(0, 0, 0, 0.45);">暂未分配权限</div>
        <el-tree
          v-else-if="!detail || edit || (infoLoadStatus === 'loaded' && authTree && authTree.length > 0)"
          ref="tree"
          :data="authTree"
          :props="{
            label: 'name',
          }"
          :default-checked-keys="form.authList"
          :expand-on-click-node="false"
          node-key="treeId"
          :show-checkbox="!detail || edit"
          default-expand-all
          style="margin-top: 4px;"
        ></el-tree>
      </el-form-item>
      <el-form-item>
        <el-button v-if="!detail" size="large" clstag="pageclick|keycount|staff_manage__50|1" type="primary" @click="addRole">创建</el-button>
        <el-button v-else-if="detail && edit" clstag="pageclick|keycount|staff_manage__53|1" type="primary" size="large" @click="updateRole">保存</el-button>
        <el-button v-if="!detail || edit" size="large" :clstag="`pageclick|keycount|${ edit ? 'staff_manage__54' : 'staff_manage__51'}|1`" @click="$router.push({ name: 'roleList' })">取消</el-button>
        <el-button v-if="detail && !edit" size="large" :clstag="`pageclick|keycount|${ edit ? 'staff_manage__54' : 'staff_manage__51'}|1`" @click="$router.push({ name: 'roleList' })">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import PageTitle from '@/components/pageTitle';
import {
  getAuthList,
  addRole,
  getRoleDetail,
  updateRole,
} from '@/api/apis/role';
import { treeBuild } from '@/utils/tree';

export default {
  name: 'RoleCreate',
  components: {
    PageTitle,
  },
  props: {
    detail: Boolean,
    edit: Boolean,
  },
  data() {
    return {
      authTree: [],
      form: {
        roleName: '',
        roleDesc: '',
        authList: [],
      },
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'change' },
          { max: 25, message: '角色名称不能超过25个字', trigger: 'change' },
        ],
        roleDesc: [
          { max: 100, message: '角色描述不能超过100个字', trigger: 'change' },
        ],
      },
      infoLoadStatus: 'wait',
    };
  },
  created() {
    if (this.detail) {
      if (!this.$route.query.id) {
        this.$message.error('页面缺少角色ID参数');
        return;
      }

      this.getRoleDetail();
    }
    if (!this.detail || this.edit) {
      this.getAuthList();
    }
  },
  methods: {
    async getRoleDetail() {
      this.infoLoadStatus = 'loading';
      const { code, data, message } = await getRoleDetail({
        roleId: this.$route.query.id,
      });

      if (code === 200) {
        this.form.roleName = data.roleName;
        this.form.roleDesc = data.roleDesc;
        let authList = [];
        (data.permissionItemList || []).forEach((item) => {
          if (item.permissions && item.permissions.length > 0) {
            authList = authList.concat(item.permissions.map((it) => it.id));
          }
        });

        if (this.detail && !this.edit) {
          const authTree = treeBuild({
            nodes: data.permissionItemList || [],
            pidKey: 'parentId',
            rootId: 0,
            formatKeys: {
              treeId: (node) => `cate-${node.id}`,
              children: (node) => {
                if (node.permissions) {
                  return node.permissions.map((item) => ({
                    treeId: item.id,
                    ...item,
                  }));
                }

                return [];
              },
            },
          });
          this.authTree = authTree;
          this.infoLoadStatus = 'loaded';
        }
        this.form.authList = authList;
      } else {
        this.infoLoadStatus = 'error';
        this.$message.error(message || '服务器异常，请稍后重试');
      }
    },
    async getAuthList() {
      const { code, data, message } = await getAuthList();
      if (code === 200 && data) {
        const authTree = treeBuild({
          nodes: data.content || [],
          pidKey: 'parentId',
          rootId: 0,
          formatKeys: {
            treeId: (node) => `cate-${node.id}`,
            children: (node) => {
              if (node.permissions) {
                return node.permissions.map((item) => ({
                  treeId: item.id,
                  ...item,
                }));
              }

              return [];
            },
          },
        });
        this.authTree = authTree;
      } else {
        this.$message.error(message || '服务器异常，请稍后重试');
      }
    },
    addRole() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          let checkNodes = this.$refs.tree.getCheckedNodes(true);
          checkNodes = checkNodes.filter((node) => typeof node.code !== 'undefined');
          const { code, message } = await addRole({
            roleName: this.form.roleName,
            roleDesc: this.form.roleDesc,
            permCodes: checkNodes.map((node) => node.code),
          });

          if (code === 200) {
            this.$message.success({
              message: '角色新建成功',
              onClose: () => {
                this.$router.push({
                  name: 'roleList',
                });
              },
            });
          } else {
            this.$message.error(message || '服务器异常，请稍后重试');
          }
        }
      });
    },
    updateRole() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid && this.$route.query.id) {
          this.$confirm('确定修改当前角色吗？', {
            confirmClstag: 'pageclick|keycount|staff_manage__55|1',
            cancelClstag: 'pageclick|keycount|staff_manage__56|1',
          }).then(async () => {
            const checkNodes = this.$refs.tree.getCheckedNodes(true);
            const { code, message } = await updateRole({
              roleId: this.$route.query.id,
              roleName: this.form.roleName,
              roleDesc: this.form.roleDesc,
              permCodes: checkNodes.map((node) => node.code),
            });

            if (code === 200) {
              this.$message.success({
                message: '角色修改成功',
                onClose: () => {
                  this.$router.push({
                    name: 'roleList',
                  });
                },
              });
            } else {
              this.$message.error(message || '服务器异常，请稍后重试');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.create-role {
  padding: 30px 20px;

  .w250 {
    width: 250px;
  }
}
</style>
